import { httpGet } from "./Web";
import { useState, useEffect } from 'react';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

export const fromDateStr = (str: string) => {
    return { y: str.slice(0, 4), m: str.slice(4, 6), d: str.slice(6, 8) }
};

export const formatDate = ({ y, m, d }: { y: string, m: string, d: string }) => {
    return `${y}-${m}-${d}`
};

export interface ApiResponse {
    failed?: boolean,
    errorCode: string | null,
    errorText: string | null,
    result?: any | null
    silent?: boolean
};

export const groupBy = (xs: any[], fun: (x: any)=>string): {[index: string]: any[]} => {
    return xs.reduce((rv, x) => {
        if(rv[fun(x)])
            rv[fun(x)].push(x);
        else
            rv[fun(x)] = [x];
        return rv;
    }, {})
}

export function unique<a>(xs: a[], cmp: (left: a, right: a) => number): a[] {
    return xs.sort(cmp).reduce((accumulator, currentValue) => {
        if(accumulator.length < 1 || cmp(accumulator[accumulator.length - 1], currentValue) !== 0 ) {
            accumulator.push(currentValue);
            return accumulator;
        }
        else
            return accumulator
    }, [] as a[])
}

export async function httpGetIds(url: string, ids?: number[]) {
    if(typeof ids !== 'undefined' && ids.length > 0) {
        let promisesArray: Array<Promise<any>> = [];

        promisesArray = ids.map(id => httpGet(`${url}/${id}`, new AbortController()));

        return Promise.all(promisesArray);
    }

    return Promise.all([httpGet(url, new AbortController())])
}

export function copyArrayWithIndexChanged<a>(array: Array<a>, index: number, newValue: a) {
    const newArray = [...array];

    if (index >= 0 && index < newArray.length) newArray[index] = newValue;
    else newArray.push(newValue);

    return newArray;
}

export function matchLeft<a,b>(lefts: a[], rights: b[], fun: (left: a, right: b) => boolean): Array<[a, b[]]> {
    return lefts.map(l => [l, rights?.filter(r => fun(l, r))]);
}

export function removeElementFromArrayCopy<a>(array: Array<a>, index: number): Array<a> {
    return [...array.slice(0,index),...array.slice(index+1)]
}

export const dropTrailingEmpty = (row: string[]) => {
    let newRow = [...row];

    for (let i = row.length - 1; i >= 0; --i)
        if (newRow[i] == "")
            newRow.pop();
        else
            break;

    return newRow;
}
/* export async function httpGetRequest(url: string, requestId: number) {
    let request = httpGet(`${url}/${requestId}`, new AbortController());
} */

//bulk http request
